import axios from 'axios';

const baseURL = process.env.REACT_APP_API_BASE_URL;

export const downloadFile = (src, filename, extension) => {
    axios.get(src, { responseType: 'arraybuffer' }).then((res) => {
        const { data } = res;

        const bytes = new Uint8Array(data);
        const blob = new Blob([bytes], { type: `application/${extension}` });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
    });
};

export const handleUploadToAzure = async (file) => {
    const config = { headers: { 'Content-Type': 'multipart/form-data' } };
    const fd = new FormData();
    fd.append('file', file);

    try {
        const response = await axios.post(`${baseURL}/uploadFile`, fd, config);

        return response.data.imageUrl;
    } catch (error) {
        console.error('Error uploading file:', error);
    }
};
